var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-mask"},[_c('md-progress-spinner',{staticClass:"modal-accent",attrs:{"md-mode":"indeterminate"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }